import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loader = new Subject<any>();
  constructor(){}
  showLoader(){
    this.loader.next({load:false})
    this.loader.next({load:true})
  }
  hideLoader(){
    this.loader.next({load:false})
  }
  getLoaderState():Observable<any>{
    return this.loader.asObservable();
  }

}
